(function (root) {
  'use strict';
  function nextDispatch(now, timeZone, locale) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    function number(type) { return Number(parts.find(function (part) { return part.type === type; }).value); }
    var tomorrow = new Date(Date.UTC(number('year'), number('month') - 1, number('day') + 1, 12));
    var date = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'long' }).format(tomorrow);
    return { date: date, day: tomorrow.toISOString().slice(0, 10) };
  }
  if (typeof module === 'object' && module.exports) module.exports = { nextDispatch: nextDispatch };
  if (!root.document) return;
  if (window.igId40Installed) return;
  window.igId40Installed = true;
  var configNode = document.getElementById('ig-id40-config');
  var template = document.getElementById('ig-id40-template');
  var dialog = document.getElementById('ig-id40-dialog');
  if (!configNode || !template || !dialog) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var active = false;
  var panel;
  var replaced;
  var opener;
  var scheduled = false;
  var variantId = String(config.selectedVariant);
  var closeReason = 'close_button';
  var clockTimer;

  function track(name, extra) {
    var properties = Object.assign({ experiment: 'ID40', product_id: config.productId, product_handle: config.handle, country: config.country, variant: 'v1' }, extra || {});
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: name, properties: properties });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, properties));
  }

  function box() { return document.querySelector('.product__info-container[data-product-handle="' + config.handle + '"]'); }
  function closeDialog(reason) { closeReason = reason || 'close_button'; if (dialog.open) dialog.close(); }
  dialog.querySelector('[data-id40-close]').addEventListener('click', function () { closeDialog('close_button'); });
  dialog.addEventListener('cancel', function () { closeReason = 'escape'; });
  dialog.addEventListener('keydown', function (event) {
    if (!dialog.open || event.key !== 'Tab') return;
    var controls = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) { return node.getClientRects().length > 0; });
    if (!controls.length) { event.preventDefault(); return; }
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog('backdrop');
  });
  dialog.addEventListener('close', function () {
    document.body.classList.remove('ig-id40-scroll-lock');
    track('guarantee_terms_close', { close_method: closeReason });
    if (active && opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.querySelector('a[href^="mailto:"]').addEventListener('click', function () { track('guarantee_support_click'); });

  function updateAvailability() {
    if (!panel) return;
    var container = box();
    var input = container && container.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) variantId = String(input.value);
    var variant = config.variants.find(function (item) { return String(item.id) === variantId; });
    var available = Boolean(variant && variant.available);
    var label = available ? config.inStock : config.unavailable;
    var target = panel.querySelector('[data-id40-availability]');
    if (target.textContent !== label) target.textContent = label;
    if (panel.dataset.available !== String(available)) panel.dataset.available = String(available);
    var dispatch = panel.querySelector('[data-id40-dispatch]');
    dispatch.hidden = !available || !config.shippingAvailable;
    if (!dispatch.hidden) {
      try {
        var deadline = nextDispatch(new Date(), config.dispatchTimezone, config.locale);
        var dateNode = dispatch.querySelector('[data-id40-date]');
        if (dateNode.textContent !== deadline.date) dateNode.textContent = deadline.date;
        dateNode.setAttribute('datetime', deadline.day);
        dateNode.dataset.timezone = config.dispatchTimezone;
      } catch (_) { dispatch.hidden = true; }
    }
  }

  function refreshClock() {
    clearTimeout(clockTimer);
    if (!active) return;
    updateAvailability();
    clockTimer = setTimeout(refreshClock, 60000 - Date.now() % 60000 + 25);
  }

  function sync() {
    scheduled = false;
    if (!active) return;
    var container = box();
    if (!container) return;
    var original = container.querySelector('.icon-with-text');
    if (!original) return;
    if (replaced && replaced !== original) replaced.removeAttribute('data-ig-id40-replaced');
    replaced = original;
    if (!panel || !panel.isConnected) {
      panel = template.content.firstElementChild.cloneNode(true);
      panel.querySelector('[data-id40-open]').addEventListener('click', function (event) {
        opener = event.currentTarget;
        if (!dialog.open) {
          dialog.showModal();
          document.body.classList.add('ig-id40-scroll-lock');
          track('guarantee_terms_open');
        }
      });
    }
    if (panel.nextElementSibling !== original) original.before(panel);
    if (!original.hasAttribute('data-ig-id40-replaced')) original.setAttribute('data-ig-id40-replaced', '');
    updateAvailability();
  }

  function schedule() {
    if (!active || scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  window.igId40ApplyVariant = function (variant) {
    active = variant === 'v1';
    if (active) { sync(); refreshClock(); }
    else {
      clearTimeout(clockTimer);
      closeDialog('variant_change');
      if (replaced) replaced.removeAttribute('data-ig-id40-replaced');
      if (panel) panel.remove();
      panel = replaced = null;
    }
  };
  document.addEventListener('change', function (event) {
    var container = box();
    if (container && container.contains(event.target)) schedule();
  });
  document.addEventListener('variant:change', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && active) refreshClock(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) variantId = String(event.data.variant.id);
      schedule();
    });
  }
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) { return !panel || !panel.contains(record.target); })) schedule();
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
  var choice = window.__ig40Variant || 'control';
  if (config.previewAllowed) {
    var requested = new URLSearchParams(window.location.search).getAll('cdxtest');
    if (requested.includes('40-v1')) choice = 'v1';
    if (requested.includes('40-control')) choice = 'control';
  }
  window.igId40ApplyVariant(choice);
})(typeof window === 'object' ? window : globalThis);
